import { PhoneIcon, MailIcon } from "./icons";

export default function ContactContent() {
    return (
        <div>
            {/* Question section */}
            <div className="flex flex-col items-center py-6 text-center">
                <span className="inline-block rounded-full border border-border px-4 py-0.5 text-xs font-medium leading-5 text-foreground">
                    Question?
                </span>
                <h3 className="mt-2 text-lg font-bold leading-7.5 text-foreground sm:text-xl lg:text-2xl">
                    You still have a question?
                </h3>
                <p className="mt-2 text-xs leading-5 text-text-light sm:text-sm sm:leading-5.5">
                    If you can&rsquo;t find an answer in our FAQ, you can contact us.
                    We&rsquo;ll answer you shortly!
                </p>
            </div>

            {/* Contact cards */}
            <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
                {/* Phone card */}
                <div className="flex flex-col items-center rounded-xl border border-border bg-background px-6 py-6">
                    <div className="flex size-9.5 items-center justify-center rounded-lg border border-border text-foreground">
                        <PhoneIcon />
                    </div>
                    <p className="mt-3 text-base font-bold leading-7.5 text-foreground sm:text-lg">
                        0903 116 7894
                    </p>
                    <p className="mt-1 text-xs leading-5 text-text-light sm:text-sm sm:leading-5.5">
                        We are always happy to help
                    </p>
                </div>

                {/* Email card */}
                <div className="flex flex-col items-center rounded-xl border border-border bg-background px-6 py-6">
                    <div className="flex size-9.5 items-center justify-center rounded-lg border border-border text-foreground">
                        <MailIcon />
                    </div>
                    <p className="mt-3 text-base font-bold leading-7.5 text-foreground sm:text-lg">
                        hello@gavel.ng
                    </p>
                    <p className="mt-1 text-xs leading-5 text-text-light sm:text-sm sm:leading-5.5">
                        Best way to get a quick answer
                    </p>
                </div>
            </div>
        </div>
    );
}
